import script from "./pagingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./pagingComponent.vue?vue&type=script&setup=true&lang=js"

import "./pagingComponent.vue?vue&type=style&index=0&id=46082256&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46082256"]])

export default __exports__